import { FC } from 'react'
import { useField } from 'formik'

import CountrySelector from 'container/SEOTools/components/CountrySelector/CountrySelector'

const OrganisationCountry: FC<{ name: string }> = ({ name }) => {
  const [field, , helper] = useField(name)
  return (
    <CountrySelector
      value={field.value}
      setValue={value => {
        helper.setValue(value)
      }}
      upperCaseValue={true}
    />
  )
}

export default OrganisationCountry
